import {
  HiOutlineLocationMarker,
  HiOutlineOfficeBuilding,
  HiOutlineVideoCamera,
  HiOutlinePresentationChartBar,
} from "react-icons/hi";

export const VISIT_TYPES = [
  { value: "site_visit", label: "Site Visit", icon: HiOutlineLocationMarker, color: "#2563EB" },
  { value: "office_meeting", label: "Office Meeting", icon: HiOutlineOfficeBuilding, color: "#7C3AED" },
  { value: "online_meeting", label: "Online Meeting", icon: HiOutlineVideoCamera, color: "#0891B2" },
  { value: "demo", label: "Demo", icon: HiOutlinePresentationChartBar, color: "#EA580C" },
];

export const VISIT_TYPE_MAP = Object.fromEntries(VISIT_TYPES.map((t) => [t.value, t]));

// variant = Badge variant; color = calendar block colour
export const VISIT_STATUSES = {
  pending_approval: { label: "Pending Approval", variant: "warning", color: "#D97706" },
  scheduled: { label: "Scheduled", variant: "primary", color: "#2563EB" },
  in_progress: { label: "In Progress", variant: "info", color: "#0891B2" },
  completed: { label: "Completed", variant: "success", color: "#16A34A" },
  cancelled: { label: "Cancelled", variant: "default", color: "#6B7280" },
  rejected: { label: "Rejected", variant: "danger", color: "#DC2626" },
  no_show: { label: "No Show", variant: "danger", color: "#B91C1C" },
  rescheduled: { label: "Rescheduled", variant: "default", color: "#9CA3AF" },
};

export const DURATION_OPTIONS = [
  { value: "15", label: "15 min" },
  { value: "30", label: "30 min" },
  { value: "45", label: "45 min" },
  { value: "60", label: "1 hr" },
  { value: "90", label: "1½ hrs" },
  { value: "120", label: "2 hrs" },
  { value: "180", label: "3 hrs" },
  { value: "240", label: "4 hrs" },
];

export const fullName = (u) =>
  u && typeof u === "object" ? `${u.firstName || ""} ${u.lastName || ""}`.trim() : "";

export const formatMinutes = (mins) => {
  const m = Math.max(0, Math.round(mins || 0));
  if (m < 60) return `${m}m`;
  return `${Math.floor(m / 60)}h${m % 60 ? ` ${m % 60}m` : ""}`;
};

export const plannedMinutes = (v) =>
  v?.scheduledStart && v?.scheduledEnd
    ? Math.round((new Date(v.scheduledEnd) - new Date(v.scheduledStart)) / 60000)
    : 0;

// Google Maps link for a {lat,lng} pin or a free-text address
export const mapsUrl = (point, address) => {
  if (point && Number.isFinite(point.lat) && Number.isFinite(point.lng)) {
    return `https://www.google.com/maps?q=${point.lat},${point.lng}`;
  }
  return address ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}` : null;
};

export const leadAddress = (lead) =>
  [lead?.address?.street, lead?.address?.city, lead?.address?.state, lead?.address?.pincode]
    .filter(Boolean)
    .join(", ");
